import React, { useEffect, useState } from 'react';
import { Filter, TextInput, SelectInput, AutocompleteInput, ReferenceInput, ExportButton, DateInput } from 'react-admin';
import { InputAdornment, Button } from '@material-ui/core';
import { Search as SearchIcon } from '@material-ui/icons';
import { rating, dateRange } from '../../utils/choices';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndo } from '@fortawesome/pro-regular-svg-icons';

const FeedbackFilters = (props) => {

  const [filter, setChartFilters] = useState({});

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      props.filtertrigger(filter)
    }, 2000)
    return () => clearTimeout(delayDebounceFn)
  }, [filter]);

  return (
    <>
      <Filter {...props}>
        <TextInput
          onChange={(e) => {
            if (e.target.value === '') {
              let filterValue = { ...filter };
              delete filterValue.sleuthName;
              setChartFilters({ ...filterValue });
            } else {
              setChartFilters({ ...filter, sleuthName: e.target.value })
            }
          }}
          alwaysOn
          source="sleuthName"
          label="Search"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon color="disabled" />
              </InputAdornment>
            ),
          }}
        />

        <ReferenceInput
          source='eventId'
          reference='event'
          alwaysOn
          filterToQuery={searchText => ( searchText ? { name: searchText } : {})}
          allowEmpty
          onChange={(e) => {
            if (e === '') {
              let filterValue = { ...filter };
              delete filterValue.eventId;
              setChartFilters({ ...filterValue });
            } else {
              setChartFilters({ ...filter, eventId: e })
            }
          }}

        >
          <AutocompleteInput />
        </ReferenceInput>
        <SelectInput
          onChange={(e) => {
            if (e.target.value === '') {
              let filterValue = { ...filter };
              delete filterValue.rating;
              setChartFilters({ ...filterValue });
            } else {
              setChartFilters({ ...filter, rating: e.target.value })
            }
          }}
          source="rating" choices={rating}
          alwaysOn
          allowEmpty
        />

        <DateInput
          alwaysOn
          source='from'
          onChange={(e) => {
            if (e === '') {
              let filterValue = { ...filter };
              delete filterValue.from;
              setChartFilters({ ...filterValue });
            } else {
              setChartFilters({ ...filter, from: e.target.value })
            }
          }}
        />

        <DateInput
          alwaysOn
          source='to'
          onChange={(e) => {
            if (e === '') {
              let filterValue = { ...filter };
              delete filterValue.to;
              setChartFilters({ ...filterValue });
            } else {
              setChartFilters({ ...filter, to: e.target.value })
            }
          }}
        />

        <SelectInput
          onChange={(e) => {
            if (e.target.value === '') {
              let filterValue = { ...filter };
              delete filterValue.range;
              setChartFilters({ ...filterValue });
            } else {
              setChartFilters({ ...filter, dateRange: e.target.value })
            }
          }}
          source="dateRange" choices={dateRange}
          alwaysOn
          allowEmpty
        />

        <ExportButton />

      </Filter>
      <Button style={{ marginTop: '15px', marginRight: '10px', paddingTop: '7px', width: '150px' }} onClick={() => { props.setFilters({}, [], false); setChartFilters({}); }}>
        <FontAwesomeIcon style={{ marginRight: '5px' }} icon={faUndo} /> Reset form
      </Button>
    </>
  );
};

export default FeedbackFilters;
